module.exports = __webpack_public_path__ + "static/media/header.2e0d7ac2.png";